module.exports = __webpack_public_path__ + "img/enigma_invert.01d8d274.png";